import XapiSection from '@efdigital/ll-admin-v2/components/client-edit/xapi-section.gts';
import type { LibraryClientsEditModel } from '@efdigital/ll-admin-v2/routes/library/clients/client';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface Signature {
  Args: {
    model: LibraryClientsEditModel;
  };
}

const XapiRoute: TemplateOnlyComponent<Signature> = <template>
  <XapiSection @xapi={{@model.xapi}} @uniqueId="xapi" @isReadOnly={{true}} />
</template>;

export default XapiRoute;
